import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as FileDownload } from "assets/morning/icon/fileDownload.svg";

interface OftenMenuProps {
    type: string;
    Image1: ReactNode;
    Image2: ReactNode;
    Image3?: ReactNode;
    content1: string;
    content2: string;
    content3?: string;
    responsive?: boolean;
    navigate1?: string;
    navigate2?: string;
    navigate3?: string;
    downloadUrl?: string;
    downloadLabel?: string;
}

const OftenMenu = ({
    type,
    Image1,
    Image2,
    Image3,
    content1,
    content2,
    content3,
    responsive,
    navigate1,
    navigate2,
    navigate3,
    downloadUrl,
    downloadLabel = "다운로드",
}: OftenMenuProps) => {
    const navigate = useNavigate();

    if (responsive) {
        return (
            <div className={`p-[10px] w-full ${type === "air" ? "bg-air" : "bg-morning"} text-white rounded-[20px]`}>
                <div className="flex justify-between text-[15px] font-[500]">
                    <div onClick={() => navigate(navigate1 || "")} className="flex flex-1 items-center gap-2 cursor-pointer">
                        <div className="w-[60px] min-h-[60px] bg-white rounded-full flex items-center justify-center">{Image1}</div>
                        <div className="flex items-center h-full">
                            <p className="text-center" dangerouslySetInnerHTML={{ __html: content1 }}></p>
                        </div>
                    </div>
                    <div onClick={() => navigate(navigate2 || "")} className="flex flex-1 items-center gap-2 cursor-pointer">
                        <div className="w-[60px] min-h-[60px] bg-white rounded-full flex items-center justify-center">{Image2}</div>
                        <div className="flex items-center h-full">
                            <p className="text-center" dangerouslySetInnerHTML={{ __html: content2 }}></p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div className={`py-[20px] px-[28px] w-[285px] ${type === "air" ? "bg-air" : "bg-morning"} text-white rounded-[20px]`}>
            {downloadUrl ? (
                <a
                    href={downloadUrl}
                    download
                    className={`group w-[225px] mb-[26px] py-[7px] flex items-center justify-center gap-1.5 rounded-full bg-white text-sm leading-[18px] font-bold no-underline transition-colors duration-200 hover:bg-gray1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white ${type === "air" ? "text-air" : "text-morning"}`}
                >
                    <FileDownload className="w-3.5 h-[17px] shrink-0 transition-transform duration-200 group-hover:translate-y-[2px]" />
                    {downloadLabel}
                </a>
            ) : (
                <p className="text-2xl w-[225px] font-bold mb-3.5">자주찾는 메뉴</p>
            )}
            <div className="flex justify-between text-[13px] font-[500]">
                <div onClick={() => navigate(navigate1 || "")} className="flex flex-col items-center gap-2 cursor-pointer">
                    <div className="w-[60px] min-h-[60px] bg-white rounded-full flex items-center justify-center">{Image1}</div>
                    <div className="flex h-full">
                        <p className="text-center" dangerouslySetInnerHTML={{ __html: content1 }}></p>
                    </div>
                </div>
                <div onClick={() => navigate(navigate2 || "")} className="flex flex-col items-center gap-2 cursor-pointer">
                    <div className="w-[60px] min-h-[60px] bg-white rounded-full flex items-center justify-center">{Image2}</div>
                    <div className="flex h-full">
                        <p className="text-center" dangerouslySetInnerHTML={{ __html: content2 }}></p>
                    </div>
                </div>
                {content3 && (
                    <div
                        onClick={() => {
                            if (navigate3?.startsWith("http")) {
                                window.open(navigate3, "_blank");
                            } else if (navigate3) {
                                navigate(navigate3);
                            }
                        }}
                        className="flex flex-col items-center gap-2 cursor-pointer"
                    >
                        <div className="w-[60px] h-[60px] bg-white rounded-full flex items-center justify-center">{Image3}</div>
                        <p className="text-center" dangerouslySetInnerHTML={{ __html: content3 }}></p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default OftenMenu;
